import type { TFunction } from "i18next";
import { isAxiosError } from "axios";
import { isExplorerConnectionWeeklyLimitError } from "./explorerConnectionLimitError";
import { getExplorerLimitMessageFromError } from "./explorerConnectionLimitCopy";

export type ConnectionRequestErrorBody = {
  message?: string;
  code?: string;
};

export function isConnectionAlreadyConnectedError(error: unknown): boolean {
  if (!isAxiosError(error)) return false;
  const data = error.response?.data as ConnectionRequestErrorBody | undefined;
  return data?.code === "connection_already_connected";
}

export function isConnectionRequestPendingError(error: unknown): boolean {
  if (!isAxiosError(error)) return false;
  const data = error.response?.data as ConnectionRequestErrorBody | undefined;
  return data?.code === "connection_request_pending";
}

export function getConnectionRequestSendErrorMessage(
  t: TFunction,
  error: unknown,
  locale: string,
  limitFallback?: { weekResetsUtc?: string; used?: number; limit?: number }
): string {
  if (isExplorerConnectionWeeklyLimitError(error)) {
    return getExplorerLimitMessageFromError(t, error, locale, {
      locale,
      ...limitFallback,
    });
  }
  if (isConnectionAlreadyConnectedError(error)) {
    return t("connections.alreadyConnected");
  }
  if (isConnectionRequestPendingError(error)) {
    return t("connections.requestAlreadyPending");
  }
  return t("connections.requestSendFailed");
}
